import { ResponseStatus } from './vars';

import { getFormData } from './apiHelper';
import {LOCAL_STORAGE} from "../../context/LocalStorage";

const sendRequest = (method, serviceParams) => {
    const {
        url,
        body,
        headers,
        requestType,
        onSuccess,
        onError,
        onInfo,
        onWarning,
        onFieldError,
        navigation
    } = serviceParams;

    let httpStatus = 0;

    return new Promise(async (resolve, reject) => {
        const token = localStorage.getItem(LOCAL_STORAGE.AUTH_TOKEN)
        let fetchDefaultHeaders = {
            Authorization: token ?? 'default'
        };
        try {
            const timeoutPromise = new Promise((resolve, reject) => {
                setTimeout(() => {
                    reject(new TypeError('Timeout'));
                }, 30000);
            });
            const BASE_URL = process.env.REACT_APP_API_URL;
            console.log(BASE_URL + url);
            const fetchPromise = fetch(BASE_URL + url, {
                method: method,
                headers: { ...fetchDefaultHeaders, ...headers },
                body: body
                    ? requestType === 'json'
                        ? JSON.stringify(body)
                        : getFormData(body)
                    : null
            })
                .then((response) => {
                    httpStatus = response.status;
                    return response.json();
                })
                .then(async (response) => {
                    response.http_status = httpStatus;
                    if (httpStatus === 401) {
                        localStorage.setItem(LOCAL_STORAGE.AUTH, JSON.stringify({}));
                        localStorage.setItem(LOCAL_STORAGE.AUTH_TOKEN, '');
                        await navigation.navigate('Login');
                    }
                    handleResponse(response, onSuccess, onError, onInfo, onWarning, onFieldError);
                    resolve(response);
                })
                .catch((e) => {
                    //cuando la petición falla por el servidor cae acá el error

                    reject(new Error('Error de servidor.'));
                });

            Promise.race([fetchPromise, timeoutPromise])
                .then((response) => {
                    resolve(response);
                })
                .catch((e) => {
                    //Cuando se cumple el tiempo de timeout acá cae

                    reject(new Error('Error de conexión al servidor.'));
                });
        } catch (error) {
            reject(error);
        }
    });
};

const handleResponse = (response, onSuccess, onError, onInfo, onWarning, onFieldError) => {
    switch (response.status) {
        case ResponseStatus.SUCCESS:
            if (onSuccess) {
                onSuccess(response);
            }
            break;
        case ResponseStatus.ERROR:
            if (onError) {
                onError(response);
            }
            break;
        case ResponseStatus.INFO:
            if (onInfo) {
                onInfo(response);
            }
            break;
        case ResponseStatus.WARNING:
            if (onWarning) {
                onWarning(response);
            }
            break;
        case ResponseStatus.FIELDS_VALIDATION:
            if (onFieldError) {
                onFieldError(response);
            }
            break;
        default:
            if (onError) {
                onError(response);
            }
            break;
    }
};

const fetchWrapper = () => {
    const doGet = (serviceParams) => {
        return sendRequest('GET', serviceParams);
    };

    const doPost = (serviceParams) => {
        return sendRequest('POST', serviceParams);
    };

    const doPut = (serviceParams) => {
        return sendRequest('PUT', serviceParams);
    };

    const doDelete = (serviceParams) => {
        return sendRequest('DELETE', serviceParams);
    };

    return {
        doGet,
        doPost,
        doPut,
        doDelete
    };
};

export default fetchWrapper;
